import { userActions } from '../context/context';
import { useUserState } from '../context/UserContext';
import { type WrappedTRPCClient } from '../helpers/trpcClientTypes';

const useOnboarding = (client: WrappedTRPCClient) => {
  const { state, dispatch } = useUserState();
  const { user } = state;

  const completeAccountSetup = async (input: {
    username: string;
    password: string;
    isPrivate?: boolean;
  }) => {
    const [error] = await client.users.completeOnboarding.mutate({
      username: input.username,
      password: input.password,
      private: input.isPrivate
    });
    if (error) return error;
    dispatch({
      type: userActions.SET_USER,
      payload: { ...user, hasPassword: true, username: input.username }
    });
    return null;
  };

  return {
    completeAccountSetup
  };
};

export default useOnboarding;
